/**
 * Generate a RFC4122 v4 compliant UUID/GUID
 * Uses native crypto.randomUUID() if available, otherwise falls back to Math.random()
 *
 * @returns {string} A valid UUID string in the format xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 *
 * @example
 * const id = generateGUID();
 * console.log(id); // "a1b2c3d4-e5f6-4789-a012-3456789abcde"
 */
export const generateGUID = () => {
  // Use native crypto.randomUUID if available (modern browsers)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback to RFC4122 v4 UUID generation for older browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Validate if a string is a valid UUID/GUID format
 *
 * @param {string} guid - The string to validate
 * @returns {boolean} True if valid UUID format, false otherwise
 *
 * @example
 * isValidGUID("a1b2c3d4-e5f6-4789-a012-3456789abcde"); // true
 * isValidGUID("invalid-guid"); // false
 */
export const isValidGUID = guid => {
  const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return guidRegex.test(guid);
};

export default {
  generateGUID,
  isValidGUID,
};
